import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  NgZone,
  Optional,
  Output,
  ViewChild
} from '@angular/core';
import { AppVersion } from '@ionic-native/app-version';
import { Device } from '@ionic-native/device';
import { Storage } from '@ionic/storage';
import 'hammerjs';
import { AlertController, App, Events, IonicPage, ModalController, Platform, ViewController } from 'ionic-angular';
import { GDAuthInterface } from '../../model/gd-auth';
import { MenuProvider } from '../../pagebuilder/services/menu/menu';
import { ChatServiceProvider } from '../../providers/chat-service/chat-service';
import { SFGOAuthService } from '../../providers/sfgoauth.service/sfgoauth.service';

import { expandVertical } from '../../animations/appear-animation';
import { ReportProblemsBloc } from '../../bloc/feature/report-problems/report-problems.bloc';
import { GDStorageInterface, StoredPrelogin } from '../../model/gd-storage';
import { Paginate } from '../../model/paginate';
import { Personal } from '../../model/personal';
import { ChatSupportService } from '../../providers/chat-support/chat-support-service';
import { GlobalServiceProvider } from '../../providers/global-service/global-service';
import { AppPreferences } from '../../shared/local/app-preferences.local';
import { PersonalNestApi } from '../../shared/nestjs/gd-only/services/personal.api';
import { PersonalApi } from '../../shared/sdk/services/custom/Personal';

/**
 * Generated class for the GdMenuPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'gd-menu',
  templateUrl: 'gd-menu.html',
  animations: [expandVertical]
})
export class GdMenuPage implements AfterViewInit {

  @Output() selectPage = new EventEmitter();
  @Output() selectVersion = new EventEmitter();
  @Output() selectBuilder = new EventEmitter();
  @Output() selectSetting = new EventEmitter();
  @Output() selectLogout = new EventEmitter();

  public builderPages: any = [];
  public screenWidth: any;
  public name: string;
  public SFGoAuth: GDAuthInterface;
  public photo: any;
  public userId: any;
  public isActive: any = 'Home';
  public decrease: boolean = false;
  public SFGoStorage: GDStorageInterface;
  public storedPrelogin: StoredPrelogin;
  public setting: any = [];

  // Gesture Hammer
  @ViewChild('holderArea') holderArea: ElementRef;
  @ViewChild('modalArea') modalArea: ElementRef;
  @ViewChild('contentArea') contentArea: ElementRef;
  public holder: any;
  public panDown: any;
  public contentPan: any;

  public isSwipeDown: boolean = false;
  public modalWrapper: any;
  public contentWrapper: any;
  public isDragging: boolean = false;
  public posYExp: any;
  public lastPosY: any;

  public scrolldisable: boolean = true;
  public scrollY: any = 0;
  public versionNumber: any;
  public unreadChat: number = 0;
  public maxMenuTab = 1420;
  public multiAccount: boolean;
  public multiAccountActive: boolean;
  private versionShow = 1;
  public firstname: any;
  public nickname: any;

  constructor(
    public menuService: MenuProvider,
    public events: Events,
    public platform: Platform,
    @Optional()
    public viewCtrl: ViewController,
    public storage: Storage,
    public ngZone: NgZone,
    public globalService: GlobalServiceProvider,
    public appVersion: AppVersion,
    public device: Device,
    public personalNestApi: PersonalNestApi,
    public alertCtrl: AlertController,
    public sfgoAuthService: SFGOAuthService,
    public personalApi: PersonalApi,
    public modalCtrl: ModalController,
    public chatServiceProvider: ChatServiceProvider,
    public app: App,
    public reportProblemsBloc: ReportProblemsBloc,
    private chatSupportService: ChatSupportService,
    public appPreferences: AppPreferences
  ) {

    this.setting = {
      groupName: 'Setting',
      group:
        [
          {
            title: 'Setting',
            component: '',
            icons: '',
            show: true,
            badgeshow: false,
            badgetext: '',
            params: {},
            builder: false,
            newicon: true,
            newiconfile: 'assets/icon_new/Setting.svg'
          },
          {
            title: 'App Version',
            component: '',
            icons: '',
            show: true,
            badgeshow: false,
            badgetext: '',
            params: {},
            builder: false,
            newicon: true,
            newiconfile: 'assets/icon_new/appversion.svg'
          },
          {
            title: 'Logout',
            component: '',
            icons: '',
            show: true,
            badgeshow: false,
            badgetext: '',
            params: {},
            builder: false,
            newicon: true,
            newiconfile: 'assets/icon_new/Logout.svg'
          },
        ]
    }

  }

  async ngOnInit() {
    this.initEvents();
    this.screenWidth = window.innerWidth;
    this.builderPages = this.menuService.pageBuilder;
    if (this.builderPages.length < 1) {
      this.events.subscribe('user:pagebuilderGD', (menu) => {
        this.builderPages = menu;
      })

    }
    this.builderPages.forEach(element => {
      element.items.forEach(elements => {
        if (!elements.iconUrl.includes('.svg')) {
          elements.iconUrl = 'assets/icon_new/icon_custom-page.svg'
        }
      });
    });

    if (window.innerWidth > this.maxMenuTab) {
      this.decrease = false;
    } else if (window.innerWidth >= 768 && window.innerWidth <= this.maxMenuTab) {
      this.decrease = true;
    }

    this.SFGoAuth = await this.sfgoAuthService.getAuthorization();
    try {
      if (this.SFGoAuth.id) {
        this.photo = this.SFGoAuth.photo;
        this.userId = this.SFGoAuth.userId;
        this.SFGoStorage = await this.sfgoAuthService.getGDStorage();
        this.storedPrelogin = this.SFGoStorage.storedPrelogin;

        // await this.getPersonalInfo(this.SFGoAuth.empId).catch(() => { })
        this.nickname = this.SFGoAuth.nickname;
        this.firstname = this.SFGoAuth.fullName.split("")[0];

        if (localStorage.getItem('accessMode') != 'jobseeker') {
          this.multiAccountActive = this.SFGoAuth.menu['multi-account'];
        } else {
          this.multiAccountActive = false;
        }

        if (this.platform.is('cordova')) {
          await this.loadVersionApp();
        }

        // this.unreadChat = this.chatServiceProvider.getUnreadCount;
        // this.reportProblemsBloc.doGetNotifMessage();
      }
    } catch (error) { }
  }

  ngOnChanges(): void {
    this.unreadChat = this.chatServiceProvider.getUnreadCount;
    console.log(this.unreadChat)
  }

  async ngAfterViewInit() {
    this.holder = this.holderArea.nativeElement;
    this.modalWrapper = this.modalArea.nativeElement;
    this.contentWrapper = this.contentArea.nativeElement;
  }

  initEvents() {
    this.events.subscribe('chat:unreadCount', (val) => {
      this.unreadChat = val
    })

    // this.events.unsubscribe('menu:multiaccount');
    // this.events.subscribe('menu:multiaccount', (data) => {
    //   if (this.screenWidth < 768 && this.viewCtrl) {
    //     setTimeout(() => {
    //       this.viewCtrl.dismiss({ action: 'switchAccount', params: data })
    //     }, 5000);
    //   }
    // });

    this.events.unsubscribe('multiaccount:switchdone');
    this.events.subscribe('multiaccount:switchdone', (data) => {
      if (this.screenWidth < 768 && this.viewCtrl) {
        this.viewCtrl.dismiss({ action: 'switchAccount' })
      }
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (window.innerWidth > this.maxMenuTab) {
      this.decrease = false;
    } else if (window.innerWidth >= 768 && window.innerWidth <= this.maxMenuTab) {
      this.decrease = true;
    }
  }

  openBuilderPage(p) {
    this.isActive = p.title;
    if (this.screenWidth >= 768) {
      this.selectBuilder.emit(p);
    } else if (this.viewCtrl) {
      this.viewCtrl.dismiss({ content: p, type: 'builder' });
    }
  }

  openPage(page) {
    this.isActive = page.title;
    if (this.screenWidth >= 768) {
      this.selectPage.emit(page);
    } else if (this.viewCtrl) {
      this.viewCtrl.dismiss(page);
    }
  }

  gotoSetting(page) {
    this.isActive = page.title;
    if (page == 'Setting') {
      this.viewCtrl.dismiss(page);
    } else {
      // for desktop
      this.selectSetting.emit();
    }
  }

  gotoLogout(page) {
    this.isActive = page.title;
    if (this.screenWidth >= 768) {
      this.selectLogout.emit();
    } else if (this.viewCtrl) {
      this.viewCtrl.dismiss(page);
    }
  }

  newLogout() {
    this.viewCtrl.dismiss('logout multi');
  }

  gotoProfile() {
    this.viewCtrl.dismiss('profil')
  }

  gotoAppVersion() {
    this.isActive = 'App Version';
    if (this.screenWidth >= 768) {
      this.selectVersion.emit();
    } else if (this.viewCtrl) {
      this.viewCtrl.dismiss('appversion')
    }
  }

  closeModal(data) {
    if (this.viewCtrl) {
      this.viewCtrl.dismiss(data)
    }
    ;
  }

  scrollMe() {
    // this.ngZone.run(() => {
    //   console.log(this.modalArea.nativeElement.scrollTop);
    //   this.scrollY = this.modalArea.nativeElement.scrollTop;
    //   if(this.scrollY == 0){
    //     this.contentPan = new window['Hammer'](this.contentWrapper);
    //     console.log(this.contentPan, "SCROLL 000");
    //     this.contentPan.get('pan').set({ direction: window['Hammer'].DIRECTION_ALL, threshold: 0 });
    //     this.contentPan.on('pan', (ev) => {
    //       if (!this.isDragging) {
    //         this.isDragging = true;
    //         this.lastPosY = 0;
    //       }
    //       this.posYExp = ev.deltaY + this.lastPosY;
    //       var outClose = this.modalWrapper.offsetHeight - 350;

    //       if (this.posYExp >= 0 && !this.isSwipeDown) {
    //         this.modalWrapper.style.transform = 'translateY(' + this.posYExp + 'px)';
    //         this.modalWrapper.style.transition = 'all 0ms';
    //       }

    //       if (ev.isFinal) {
    //         this.isDragging = false;
    //         if(this.posYExp > outClose && !this.isDragging){
    //           this.modalWrapper.style.transform = 'translateY(100%)';
    //           this.modalWrapper.style.transition = 'all 200ms';
    //           setTimeout(() => {
    //             this.viewCtrl.dismiss('close');
    //             console.log('trigger CLOSE');
    //           }, 100);
    //         }else if(!this.isSwipeDown){
    //           this.modalWrapper.style.transform = 'translateY(0px)';
    //           this.modalWrapper.style.transition = 'all 250ms';
    //         }
    //         if(this.posYExp < 0){
    //           this.contentPan.remove('pan');
    //           this.scrolldisable = false;
    //         }
    //       }
    //       console.log(this.posYExp);
    //       console.log(outClose);
    //       console.log(this.scrollY);
    //     });
    //   }
    // });
  }

  ionViewDidLoad() {

    // SWIPE Gesture start
    let swipe = new window['Hammer'](this.holder); // object element for SWIPE Gesture
    swipe.get('swipe').set({ direction: window['Hammer'].DIRECTION_ALL }); // get a "SWIPE" recognizer to it (all directions)
    swipe.on('swipedown', (ev) => { // SWIPE Function
      var outClose = this.modalWrapper.offsetHeight - 350;

      if (ev.isFinal) { // Final or end Gesture used
        this.isSwipeDown = true; // Status SwipeDown set true
        if (this.posYExp <= outClose && ev.type == 'swipedown' && this.isSwipeDown) {
          this.modalWrapper.style.transform = 'translateY(100%)';
          this.modalWrapper.style.transition = 'all 250ms';
          setTimeout(() => {  // Delay to dissmiss for get transition animation timing
            this.viewCtrl.dismiss('close');
          }, 150);
        }
      }
    });
    // SWIPE Gesture end

    // PAN Gesture start
    this.panDown = new window['Hammer'](this.holder); // object element for PAN Gesture
    this.panDown.get('pan').set({ direction: window['Hammer'].DIRECTION_ALL, threshold: 0 }); // get a "PAN" recognizer to it (all directions)
    this.panDown.on('pan', (ev) => { // PAN Function
      // console.log(ev.type);
      if (!this.isDragging) {
        this.isDragging = true;
        this.lastPosY = 0;
      }
      this.posYExp = ev.deltaY + this.lastPosY;
      var outClose = this.modalWrapper.offsetHeight - 350;

      if (this.posYExp >= 0 && !this.isSwipeDown) {
        this.modalWrapper.style.transform = 'translateY(' + this.posYExp + 'px)';
        this.modalWrapper.style.transition = 'all 0ms';
      }

      if (ev.isFinal) { // Final or end Gesture used
        this.isDragging = false;
        if (this.posYExp > outClose && !this.isDragging) {
          this.modalWrapper.style.transform = 'translateY(100%)';
          this.modalWrapper.style.transition = 'all 200ms';
          setTimeout(() => {  // Delay to dissmiss for get transition animation timing
            this.viewCtrl.dismiss('close');
          }, 100);
        } else if (!this.isSwipeDown) {
          this.modalWrapper.style.transform = 'translateY(0px)';
          this.modalWrapper.style.transition = 'all 250ms';
        }
      }
    });
    // PAN Gesture end
  }

  async showionicversion(version) {
    console.log(this.versionShow);
    if (this.versionShow >= 7 && this.platform.is('cordova')) {

      const myMessage = 'Ionic ' + version + '<br />' +
        'App Package ' + await this.appVersion.getPackageName() + '<br />' +
        'App Version ' + await this.appVersion.getVersionNumber() + '<br />' +
        'App Code ' + await this.appVersion.getVersionCode() + '<br />' +
        'Cordova ' + this.device.cordova + '<br />' +
        'Model ' + this.device.model + '<br />' +
        'Platform ' + this.device.platform + '<br />' +
        'Uuid ' + this.device.uuid + '<br />' +
        'Version ' + this.device.version + '<br />' +
        'Manufacturer ' + this.device.manufacturer + '<br />' +
        'IsVirtual ' + this.device.isVirtual + '<br />' +
        'Serial ' + this.device.serial;


      const alert = this.alertCtrl.create({
        message: myMessage,
        buttons: [
          {
            text: 'Dismiss',
            handler: () => {
              this.versionShow = 1;
              // this.showStore();
            }
          }]
      });
      alert.present();
    } else {
      this.versionShow += 1;
    }
  }

  async toggleLayout() {
    this.viewCtrl.dismiss('home2page');
  }

  loadVersionApp(): Promise<any> {
    return new Promise(async (resolve) => {
      this.versionNumber = await this.appVersion.getVersionNumber();
      resolve(this.versionNumber);
    })
  }

  async userfeed() {
    if (this.platform.is('cordova')) {
      await this.chatSupportService.setIdentity(this.SFGoAuth.fullName, this.SFGoAuth.email);
      await this.chatSupportService.showChat();
    } else {
      this.app.getActiveNav().push('ProblemOptionsPage', { from: 'menu' });
    }
  }

  multiAccountShow() {
    if (this.multiAccountActive) {
      this.multiAccount = !this.multiAccount;
    }
  }

  getPersonalInfo(empId): Promise<Paginate<Personal>> {
    return new Promise((resolve, reject) => {
      let data;
      if (this.storedPrelogin.hasOwnProperty('GOPATHNEW')) {
        this.personalNestApi.getPersonal(empId)
          .subscribe(
            async (result) => {
              data = await this.globalService.convertObjToCamelCase(result.data);
              if (empId === this.SFGoAuth.empId) {
                this.nickname = data.initialName;
                this.firstname = data.firstName;
              }
              resolve(data);
            },
            error => {
              reject(false)
              console.log(error)
            }
          )
      } else {
        this.personalApi.getPersonal(empId).subscribe(
          async (result: Paginate<Personal>) => {
            data = await this.globalService.convertObjToCamelCase(result.data[0]);
            if (empId === this.SFGoAuth.empId) {
              this.nickname = data.initialName;
              this.firstname = data.firstName;
            }
            resolve(result)
          }, error => {
            reject(false)
          })
      }
    })
  }

}



// WEBPACK FOOTER //
// ./src/components/gd-menu/gd-menu.ts